import client from "api/client";
import {AxiosError} from "axios";
import {queries} from "shared/api/queries";
import {ConfirmCodeApiResponse} from "features/login/types";
import {TApiError} from "shared/types";

export const signin = (username: string, password: string, onSuccess: (data: ConfirmCodeApiResponse) => void, onError: (err: AxiosError<TApiError>) => void) => {
  client
  .post(queries.auth.signin, {
    username, password,
  })
  .then((res) => {
    onSuccess(res.data);
  })
  .catch(onError);
};

export const signout = (refresh: string, onSuccess: () => void, onError: (e: AxiosError<TApiError>) => void) => {
  client
  .post(queries.auth.signout, {refresh})
  .then(onSuccess)
  .catch(onError);
};
